module.exports = __webpack_public_path__ + "b71e08bcebcdb87fcbfee2e443aa13df.svg";